import { render, staticRenderFns } from "./_Section7-2.vue?vue&type=template&id=2af2c5ac&"
import script from "./_Section7-2.vue?vue&type=script&lang=js&"
export * from "./_Section7-2.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports